import type { GameMeta } from '@gmp/game-sdk';

export const humanResourcesMeta = {
  id: 'human-resources',
  name: 'Human Resources',
  tagline: 'A ridiculous job, a pile of even more ridiculous applicants, and one manager with a rubber stamp.',
  description:
    'Every round a bizarre job opens ("Dragon Dentist: must be fireproof, patient and good with flossing"). One player is the hiring manager; everyone else is dealt an absurd applicant with one great benefit and one disqualifying weakness, plus a secret objective. Applicants answer interview questions or write a short pitch. The resumes go up anonymously, everyone predicts who gets the job, and the manager stamps one HIRED. The manager role rotates. Play over a coffee break or over a week.',
  minPlayers: 3,
  maxPlayers: 12,
  estimatedMinutes: [15, 35],
  usesMedia: false,
  modes: [{ id: 'hiring', name: 'Hiring rounds', description: 'One round per player by default, so everyone is the hiring manager once.' }],
  theme: { primary: '#3b7be8', secondary: '#e0453a', background: '#10161f', ink: '#f6f2e8' },
  readiness: 'beta',
  genre: 'Ridiculous hiring and social prediction',
  controls: 'tap',
  category: 'async',
  asyncInfo: {
    turnSeconds: [30, 90],
    match: { quick: '15–35 min', daily: '4–12 days' },
    difficulty: 'easy',
    tags: ['funny', 'social', 'prediction', 'bluffing'],
  },
  instructions: [
    { icon: 'Briefcase', title: 'The opening', body: 'Each round a bizarre job opens with three requirements. One player is the hiring manager; the role rotates so everyone gets a turn.' },
    { icon: 'FileUser', title: 'Your applicant', body: 'Everyone else is dealt an absurd applicant with a benefit and a disqualifying weakness, plus a secret objective. Answer three interview questions or write a short pitch, and choose which requirement you lead with.' },
    { icon: 'EyeOff', title: 'Predict the hire', body: 'The resumes go up anonymously. Everyone else predicts who gets the job while the manager picks one and says which requirement won it.' },
    { icon: 'Stamp', title: 'HIRED', body: 'The hire scores 3, right predictions 1 (2 for a bold call), and a completed secret objective 2. Steps move on when everyone is in or the time runs out.' },
  ],
} satisfies GameMeta;
